module.exports = __webpack_public_path__ + "img/nl-icon.e2fc1c43.svg";